import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { MyOrganizationService } from 'libs/data/src/lib/services/my-organization/my-organization.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-list-of-suppliers',
  templateUrl: './list-of-suppliers.component.html',
  styleUrls: ['./list-of-suppliers.component.scss'],
})
export class ListOfSuppliersComponent {
  @Output() saveSupplierEvent = new EventEmitter<any>();
  modalLabel: any;
  supplierData: any;
  supplierAddEditForm!: FormGroup;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    public myOrganizationService: MyOrganizationService,
    private sharedService: SharedService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.supplierData = this.modal?.modalService?.config?.initialState?.['supplierData'];
  }

  ngOnInit(): void {
    this.supplierAddEditForm = this.formBuilder.group({
      name: [this.supplierData.name || '', Validators.required],
    });
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    if (this.supplierAddEditForm.controls['name'].value != '' || null) {
      const supplierAddEditPayload = {
        supplierId: this.supplierData.supplierId || 0,
        name: this.supplierAddEditForm.controls['name'].value.trimStart(),
      };
      this.sharedService.updatedSupplierName(supplierAddEditPayload);
    }
  }
}
